<template>
  <v-dialog v-model="isTheModalOpen" persistent>
    <v-card>
      <v-progress-linear
        :active="isLoadingRequestDisable"
        indeterminate
        color="green accent-4"
        height="7"
      ></v-progress-linear>
      <v-card-title>
        <span>{{ modalFormTitle }}</span>
        <v-card-text>
          <v-container>
            <v-row>
              <slot></slot>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-4" text @click="onCloseModalEvent">Fechar</v-btn>
        <v-btn
          color="green darken-1"
          text
          v-if="isModalButtonVisible"
          :disabled="isModalButtonDisabled"
          @click="emitModalActionEvent"
          >{{ modalButtonText }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modalFormTitle: String,
    modalButtonText: String,
    modalType: String,
    isTheModalOpen: Boolean,
    isModalButtonDisabled: Boolean,
    isModalButtonVisible: Boolean,
    isLoadingRequestDisable: Boolean,
  },

  methods: {
    onOpenModalEvent() {
      this.$emit("formmodal-open");
    },
    onCloseModalEvent() {
      if (confirm("Você deseja realmente fechar essa janela? todos dados escritos nela serão perdidos?")) {
        this.$emit("formmodal-close");
      }
    },
    emitModalActionEvent() {
      this.$emit("formmodal-action", this.modalType);
    },
  },
};
</script>